import React, { Component } from 'react'

class IconTrophySilver extends Component {
  render() {
    return (
      <svg width="60" height="59" className="icon-trophy">
        <g fill="none" fillRule="evenodd">
          <path
            fill="#B4B4B4"
            fillRule="nonzero"
            d="M35.468 49.331h-10.99l1.873-3.997 1.624-3.746h3.996l1.624 3.746z"
          />
          <path
            fill="#E9E9E9"
            fillRule="nonzero"
            d="M41.038 49.33H18.896c-1.218 0-2.215 1.125-2.215 2.499v7.026h26.46V51.83c.11-1.374-.886-2.498-2.103-2.498z"
          />
          <path
            fill="#D3D3D3"
            fillRule="nonzero"
            d="M0 6.869v5.12c0 12.49 7.743 23.23 18.608 27.726 3.497 1.498 7.369 2.247 11.365 2.247 3.997 0 7.868-.749 11.365-2.247 10.865-4.496 18.608-15.237 18.608-27.726V6.87H0zm54.95 5.12c0 5.995-2.122 11.49-5.744 15.861-4.62 5.495-11.49 9.117-19.233 9.117S15.361 33.47 10.74 27.85c-3.496-4.246-5.744-9.866-5.744-15.86v-.126h49.83v.125h.125zM49.456 0H10.49c-.875 0-1.5.75-1.5 1.499 0 .874.625 1.623 1.5 1.623h38.965c.874 0 1.498-.749 1.498-1.498C50.954.749 50.33 0 49.456 0z"
          />
          <path
            fill="#E9E9E9"
            fillRule="nonzero"
            d="M49.456 3.122V16.61c0 12.489-7.743 23.854-19.483 28.35-11.74-4.621-19.482-15.861-19.482-28.475V3.122h38.965z"
          />
          <path fill="#C2C2C2" fillRule="nonzero" d="M10.491 3.122h38.84v1.873h-38.84z" opacity=".312" />
          <path
            fill="#D3D3D3"
            d="M24.087 27.818V10.364h7.955c3.728 0 5.028 2.902 3.14 5.58l-.893 1.265c6.256 3.102 4.222 10.61-2.527 10.61h-7.675zm7.57-12.194c.395-.592.478-.965.478-1.38 0-1.16-1.004-2.135-2.16-2.135h-2.398v13.964h1.328c2.223 0 3.909-1.219 3.909-4.074 0-2.355-1.088-3.612-2.715-4.011l1.558-2.364z"
          />
        </g>
      </svg>
    )
  }
}

export default IconTrophySilver



// WEBPACK FOOTER //
// ./src/svg/icon-trophysilver.js